<template>
    <div class="leftBar"></div>
</template>

<style lang="less" scoped>
.leftBar {
    height: 100%;
    width: 100%;
    float: left;
}
</style>

<script>
export default {
    props: {
        title: String,
        data: Array,
    },
    name: '',
    data() {
        return {
            myChart: null
        }
    },
    watch: {
    // 监听 data 属性的变化，深度监听
    data: {
      deep: true,
      handler() {
        this.setChart(); // 数据更新时重新渲染图表
      }
    }
  },
    methods: {
        setTrenchData(type) { // 数据
            let arr = [];
            let obj = {};
            for (let i = 0; i < this.data.length; i++) {
                switch (type) {
                    case 't':
                        obj = {
                            subtext: this.data[i].subtitle,
                            top: this.data[i].top,
                            left: '8%',
                            subtextStyle: {
                                color: '#8CBCCD',
                                fontSize: 11
                            }
                        }
                        break;
                    case 'd':
                        obj = this.data[i].data
                        break;
                    case 'b':
                        obj = 100;
                        break;
                    default:
                        break;
                }

                arr.push(obj);
            }
            if (type === 't') { // 标题
                arr.unshift({
                    text: this.title,
                    top: '2%',
                    left: '3%',
                    textStyle: {
                        color: '#fff',
                        fontSize: 12
                    }
                });
            }
            return arr;
        },

        // 渠道分析
        setChart() {
            let effectData = this.setTrenchData('d').map((item, index) => {
            return {
                coords: [
                    [0, index],
                    [item.value, index]
                ]
            };
        });
            let option = {
                tooltip: {
                    trigger: 'item',
                    axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                        type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                    },
                },
                title: this.setTrenchData('t'),
                grid: {
                    top: '15%',
                    bottom: '3%',
                    left: '8%',
                },
                yAxis: {
                    data: [],
                    inverse: true,
                    axisLabel: {show: false},
                    axisLine: {show: false},
                    axisTick: {show: false},
                },
                xAxis: {
                    splitLine: {show: false},
                    axisLabel: {show: false},
                    axisLine: {show: false},
                    axisTick: {show: false},
                },
                series: [{
                    type: 'bar',
                    silent: true,
                    barWidth: 18,
                    barGap: '-100%', // Make series be overlap
                    itemStyle: {
                        color: '#1F1E4E'
                    },
                    data: this.setTrenchData('b')
                }, {
                    type: 'bar',
                    barWidth:18,
                    z: 2,
                    label: {
                        show: true,
                        position: "insideLeft",
                        color: "#fff",
                        offset: [1, -2],
                        fontSize: 11,
                        formatter: function (params) {
                            return params.name
                        },
                    },
                    itemStyle: {
                        color: function (params) {
                            return params.data.color;
                        }
                    },
                    data: this.setTrenchData('d')
                },
                {
            type: 'lines',
            coordinateSystem: 'cartesian2d',
            data: effectData,
            effect: {
                show: true,
                period: 2,
                trailLength: 0.5, // 控制拖尾长度
                symbolSize: 10, // 调整流光大小以适配图表
                symbol: 'triangle', // 这里可以更改为其他形状，比如 'rect', 'triangle' 等
                loop: true,
                color: '#fff' // 流光颜色
            },
            lineStyle: {
                width: 0, // 线条宽度
                opacity: 0.6, // 线条的不透明度
                curveness: 0 // 线条的曲率
            },
            z: 99 // 设置组件的 z 方向高度
            }
            ]
            };
            if (!this.myChart) this.myChart = this.$echarts(this.$el);

            this.myChart.clear();
            this.myChart.resize();
            this.myChart.setOption(option);
        },

    },
    mounted() {
        this.setChart();
    },
}
</script>
